module.exports = __webpack_public_path__ + "static/cad-designs13-b18801698940628edfd89d6f656db48c.png";